import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { AudienceSection } from '../components/AudienceSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-[#FAF6F0] overflow-x-hidden" data-id="element-206">
      <HeroSection data-id="element-207" />
      <ProblemSection data-id="element-208" />
      <SolutionSection data-id="element-209" />
      <ProductDetailsSection data-id="element-210" />
      <AudienceSection data-id="element-211" />
      <OfferSection data-id="element-212" />
      <Footer data-id="element-213" />
    </main>;
}